<template>
  <div
    class="tm-custom-select"
    :class="{ open: dropdownOpen, disabled: disabled }"
    @click="toggleDropdown"
    @blur="handleBlur"
    tabindex="0"
  >
    <div class="tm-custom-select__selected">
      <input
        type="text"
        :value="selectedLabel"
        :placeholder="placeholder"
        readonly
      />
      <span class="dct-fonts-arrow-down"></span>
    </div>
    <transition name="fade">
      <ul v-if="dropdownOpen" class="tm-custom-select__dropdown">
        <li
          v-for="option in options"
          :key="option.value"
          :class="{ selected: option.value === localValue, disabled: disabled }"
          @click.stop="selectOption(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: "tm-select",
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    validation: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localValue: "",
      dropdownOpen: false,
    };
  },
  computed: {
    selectedLabel() {
      const found = this.options.find((opt) => opt.value === this.localValue);
      return found ? found.label : "";
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectOption(option) {
      if (this.disabled) return;
      if (option.value === this.localValue) {
        this.dropdownOpen = false;
        return;
      }
      this.localValue = option.value;
      this.$emit("input", this.name, option.value);
      this.$emit("change", this.name, option.value);
      this.validation.forEach((rule) => {
        if (rule.trigger === "change") {
          this.$emit("trigger", this.name, option.value);
        }
      });
      this.dropdownOpen = false;
    },
    handleBlur() {
      // 失焦时关闭下拉
      this.dropdownOpen = false;
      this.$emit("blur");
    },
    handleFocus() {
      this.$emit("focus");
    },
  },
};
</script>

<style scoped>
.tm-custom-select {
  position: relative;
  width: 100%;
  min-width: 200px;
  user-select: none;
  outline: none;
  cursor: pointer;
  font-size: 15px;
}
.tm-custom-select.disabled {
  pointer-events: none;
  opacity: 0.6;
  background: #f5f5f5;
}
.tm-custom-select__selected {
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.3s;
  min-height: 40px;
}
.tm-custom-select__selected input {
  border: none;
  outline: none;
  width: 100%;
  cursor: pointer;
}
.tm-custom-select.open .tm-custom-select__selected {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}
.tm-custom-select__placeholder {
  color: #bbb;
}
.tm-custom-select.open .dct-fonts-arrow-down {
  transform: rotate(180deg);
}
.dct-fonts-arrow-down {
  transition: transform 0.2s;
  color: #666;
  font-size: 14px;
}
.tm-custom-select__dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 10;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 2px;
  max-height: 220px;
  overflow-y: auto;
  padding: 0;
  list-style: none;
  text-align: left;
  animation: fadeIn 0.2s;
}
.tm-custom-select__dropdown li {
  padding: 4px 16px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 15px;
}
.tm-custom-select__dropdown li.selected {
  color: #3498db;
}
.tm-custom-select__dropdown li:hover:not(.disabled) {
  background: #f0f0f0;
}
.tm-custom-select__dropdown li.disabled {
  color: #bbb;
  cursor: not-allowed;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
